export const TAG_ID_KEY = 'id';
export const TAG_NAME_KEY = 'name';
export const TAG_CUSTOMER_ID_KEY = 'customerId';
export const TAG_COLOR_KEY = 'color';
export const TAG_ACTIVE_KEY = 'active';
export const TAG_CREATED_AT_KEY = 'createdAt';
export const TAG_CREATED_BY_KEY = 'createdBy';
export const TAG_MODIFIED_AT_KEY = 'modifiedAt';
export const TAG_MODIFIED_BY_KEY = 'modifiedBy';
export const TAG_DETAIL_KEY = 'detail';
export const TAG_DELETED_AT_KEY = 'remove';
// Parking Tag
export const PARKING_TAG_TABLE_KEY = 'v1/parking-tag';
export const PARKING_TAG_QUERY_KEY = 'parkingTagData';
export const PARKING_TAG_TABLE_SETTINGS = 'parking_tag';
// Ride Tag
export const RIDE_TAG_TABLE_KEY = 'v1/ride-tag';
export const RIDE_TAG_TABLE_SETTINGS = 'ride_tag';
export const RIDE_TAG_QUERY_KEY = 'rideTagData';

export const ParkingTagSettingsKeys = {
  name: 'table_list.columns.parkingTags.name',
  customerId: 'table_list.columns.customerId',
  color: 'table_list.columns.parkingTags.color',
  active: 'table_list.columns.parkingTags.active',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
};
export const RideTagTableSettingsKeys = {
  name: 'table_list.columns.rideTags.name',
  customerId: 'table_list.columns.customerId',
  color: 'table_list.columns.parkingTags.color',
  active: 'table_list.columns.parkingTags.active',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
};
